module.exports = __webpack_public_path__ + "static/cafe04-f323a784f182a6a0f69554f44709ce40.jpg";